<template>
  <div class="web-video" :class="{'web-video-shu':videoTypes==$store.state.sys.p0VideoShu}">
    <!-- <div id="id_test_video" style="width:100%; height:auto;"></div> -->
    <video id="player-container-id1" proload="auto" style="width:100%; height:100%;" playsinline
      webkit-playsinline></video>
  </div>
</template>

<script>
  export default {
    name: 'Details',
    props: {
      videoUrl: {
        type: String
      },
      videoType: {}
    },
    data() {
      videoTypes: ""
    },
    watch: {
      // 监听video url变化
      videoUrl(val) {
        if (this.videoPlayer == null) {
          this.init(val);
        } else {
          this.videoPlayer.src(val);
          this.videoPlayer.play();
        }
      },
      // 监听父组件数据变化
      videoType: {
        handler(newVal, oldVal) {
          this.videoType = newVal;
          newVal && this.getVideoType();
        },
        immediate: true, // 监听到数据变化时立即调用
        deep: true
      },
    },
    data() {
      return {
        videoPlayer: null,
        videoTypes: this.$store.state.sys.p0Video,
      }
    },
    mounted() {
      this.$nextTick(function() {
        let that = this;
        setTimeout(function() {
          if (that.videoUrl !== "") {
            that.init(that.videoUrl);
          }
        }, 20)
      })
    },
    destroyed: function() {
      if (this.videoPlayer !== null) {
        this.videoPlayer.dispose();
      }
    },
    methods: {
      getVideoType() {
        this.videoTypes = this.videoType;
      },
      init(val) {
        this.videoPlayer = TCPlayer('player-container-id1', {
          sources: [{
            src: val
          }],
        });
        this.videoPlayer.play();

        // this.videoPlayer = new TcPlayer('id_test_video', {
        //   "m3u8": val,
        //   "flv": val,
        //   "mp4": val,
        //   "rtmp": val,
        //   "live": this.live,
        //   // "poster": {
        //   //   "style": "stretch",
        //   //   "src": this.videoPoster
        //   // },
        //   "wording": {
        //     1: "网络错误，请检查网络配置或者播放链接是否正确。",
        //     2: "网络错误，请检查网络配置或者播放链接是否正确。",
        //     3: "视频解码错误。",
        //     4: "当前系统环境不支持播放该视频格式。",
        //     5: "当前系统环境不支持播放该视频格式。",
        //     10: "请勿在 file 协议下使用播放器，可能会导致视频无法播放。",
        //     11: "使用参数有误，请检查播放器调用代码。",
        //     12: "请填写视频播放地址。",
        //     13: "直播已结束，请稍后再来。",
        //     1001: "网络错误，请检查网络配置或者播放链接是否正确。",
        //     1002: "获取视频失败，请检查播放链接是否有效。",
        //     2032: "请求视频失败，请检查网络",
        //     2048: "请求m3u8文件失败，可能是网络错误或者跨域问题"
        //   },
        //   "autoplay": true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
        //   "width": '100%', //视频的显示宽度
        //   "height": '100%' //视频的显示高度
        // });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .web-video {
    width: 100%;
    height: 675px;
  }

  #web-details .web-video {
    height: 422px;
  }

  .web-video-shu {
    width: 540px;
    height: 960px;
    margin: 0 auto;
  }

  #web-details .web-video.web-video-shu {
    height: 960px;
  }

  #id_test_video {
    height: 100% !important;
  }

  @media screen and (max-width: 800px) {
    .web-video {
      height: 54vw;
    }

    #web-details .web-video {
      height: 53vw;
    }

    .web-video-shu {
      width: 100%;
      height: 170vw;
    }

    #web-details .web-video.web-video-shu {
      height: 170vw;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Video.vue